import update from 'immutability-helper'

import * as actions from '../../actions/actions'

const initialState = {
  corporateToCreate: {
    corporateSenderId: '',
    corporateSenderName: '',
    enabled: false,
    bank: '',
    logo:'',
    autoAccept:true,
    timeToExpiry:30,
    daysToFirstReminder:10,
    daysToSecondReminder:2,
    whatsapp:true,
    primaryColor:'#38719d',
    secondaryColor:'#b62377',
    hasBankAuthorizer:false
  },
  noAuthorizer:false,
  error: ''
}

export default function corporateCreate(state = initialState, action) {
  switch (action.type) {
    case actions.CREATE_CORPORATE_CORPORATE_SENDER_ID_FIELD_CHANGE:
      return createCorporateCorporateSenderIdFieldChange(state, action)
    case actions.CREATE_CORPORATE_CORPORATE_HAS_BANK_AUTHORIZER_ENABLE_CHANGE:
      return createCorporateCorporateHasBankAuthorizerFieldChange(state, action)
    case actions.CREATE_CORPORATE_CORPORATE_HAS_BANK_AUTHORIZER_DISABLE_CHANGE:
      return createCorporateCorporateHasBankAuthorizerFieldDisableChange(state, action)
    case actions.CREATE_CORPORATE_CORPORATE_HAS_BANK_AUTHORIZER_EXISTS:
      return createCorporateCorporateHasBankAuthorizerExists(state, action)
    case actions.CREATE_CORPORATE_CORPORATE_AUTOACCEPT_FIELD_CHANGE:
      return createCorporateCorporateAutoAcceptFieldChange(state, action)
    case actions.CREATE_CORPORATE_CORPORATE_TIME_TO_EXPIRE_FIELD_CHANGE:
      return createCorporateCorporateTimeToExpireFieldChange(state, action)
    case actions.CREATE_CORPORATE_CORPORATE_WHATSAPP_FIELD_CHANGE:
      return createCorporateCorporateWhatsapppFieldChange(state, action)
    case actions.CREATE_CORPORATE_CORPORATE_DAYS_TO_FIRST_REMINDER_FIELD_CHANGE:
      return createCorporateCorporateDaysToFirstReminderFieldChange(state, action)
    case actions.CREATE_CORPORATE_CORPORATE_DAYS_TO_SECOND_REMINDER_FIELD_CHANGE:
      return createCorporateCorporateDaysToSecondReminderFieldChange(state, action)
    case actions.CREATE_CORPORATE_CORPORATE_SENDER_NAME_FIELD_CHANGE:
      return createCorporateCorporateSenderNameFieldChange(state, action)
    case actions.CREATE_CORPORATE_ENABLED_FILED_CHANGE:
      return createCorporateEnabledFieldChange(state, action)
    case actions.CREATE_CORPORATE_ID_BANK_FIELD_CHANGE:
      return createCorporateIdBankFieldChange(state, action)
    case actions.CREATE_CORPORATE_CLEAN:
      return createCorporateClean(state, action)
    case actions.SAVE_CORPORATE_CREATE_FAILURE:
      return createCorporateError(state,action)
    case actions.CREATE_CORPORATE_CORPORATE_LOGO_FILED_CHANGE:
      return createCorporateCorporateLogoFieldChange(state, action)
    case actions.CREATE_CORPORATE_PRIMARY_COLOR_CHANGE:
      return createCorporatePrimaryColorChange(state,action)
    case actions.CREATE_CORPORATE_SECONDARY_COLOR_CHANGE:
      return createCorporateSecondaryColorChange(state,action)
    default:
      return state
  }
}

const createCorporateError = (state,action) =>{
  return {
    ...state,
    error: action.error
  }
}

const createCorporateCorporateLogoFieldChange = (state, action) => {
  return update(
    state,
    {corporateToCreate: {logo: {$set: action.value}}}
  )
}

const createCorporateCorporateSenderIdFieldChange = (state, action) => {
  return update(
    state,
    {corporateToCreate: {corporateSenderId: {$set: action.value}}}
  )
}

const createCorporateCorporateHasBankAuthorizerFieldChange = (state, action) => {
  return update(
      state,
      {corporateToCreate: {hasBankAuthorizer: {$set: true}}}
  )
}

const createCorporateCorporateHasBankAuthorizerFieldDisableChange = (state, action) => {
  return update(
      state,
      {corporateToCreate: {hasBankAuthorizer: {$set: false}}}
  )
}
const createCorporateCorporateHasBankAuthorizerExists = (state, action) => {
  return update(
      state,
      {noAuthorizer: {$set: action.value}}
  )
}



/*const createCorporateCorporateWhatsappFieldChange = (state, action) => {
  return update(
      state,
      {corporateToCreate: {whatsapp: {$set: action.value}}}
  )
}*/

const createCorporateCorporateAutoAcceptFieldChange = (state, action) => {
  return update(
      state,
      {corporateToCreate: {autoAccept: {$set: action.value}}}
  )
}

const createCorporateCorporateWhatsapppFieldChange = (state, action) => {
  return update(
      state,
      {corporateToCreate: {whatsapp: {$set: action.value}}}
  )
}

const createCorporateCorporateTimeToExpireFieldChange = (state, action) => {
  return update(
      state,
      {corporateToCreate: {timeToExpiry: {$set: action.value}}}
  )
}
const createCorporateCorporateDaysToFirstReminderFieldChange = (state, action) => {
  return update(
      state,
      {corporateToCreate: {daysToFirstReminder: {$set: action.value}}}
  )
}

const createCorporateCorporateDaysToSecondReminderFieldChange = (state, action) => {
  return update(
      state,
      {corporateToCreate: {daysToSecondReminder: {$set: action.value}}}
  )
}

const createCorporateCorporateSenderNameFieldChange = (state, action) => {
  return update(
    state,
    {corporateToCreate: {corporateSenderName: {$set: action.value}}}
  )
}

const createCorporateEnabledFieldChange = (state, action) => {
  return update(
    state,
    {corporateToCreate: {enabled: {$set: action.value}}}
  )
}

const createCorporateIdBankFieldChange = (state, action) => {
  return update(
    state,
    {corporateToCreate: {bank: {$set: action.value}}}
  )
}

const createCorporateClean = (state, action) => {
  return initialState;
}

const createCorporatePrimaryColorChange = (state, action) => {
  return update(
    state,
    {corporateToCreate: {primaryColor: {$set: action.value}}}
  )
}

const createCorporateSecondaryColorChange = (state, action) => {
  return update(
    state,
    {corporateToCreate: {secondaryColor: {$set: action.value}}}
  )
}